import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { getUserEnrollments } from '../actions/getUserEnrollments';

export const userEnrollmentsQueryKey = (onerosterUserId: string) => [
  'userEnrollments',
  onerosterUserId,
];

export const userEnrollmentsQueryOptions = (onerosterUserId: string) =>
  queryOptions({
    queryKey: userEnrollmentsQueryKey(onerosterUserId),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5, // 5 minutes
    queryFn: async () => {
      const response = await getUserEnrollments({
        data: { onerosterUserId },
      });

      if (!response.success) {
        throw new Error(response.error);
      }

      return response.data;
    },
  });

export const useUserEnrollments = (onerosterUserId: string) => {
  return useQuery(userEnrollmentsQueryOptions(onerosterUserId));
};
